import { render, staticRenderFns } from "./OfficeGeneralForm.vue?vue&type=template&id=f22e6b4a&scoped=true"
import script from "./OfficeGeneralForm.vue?vue&type=script&lang=js"
export * from "./OfficeGeneralForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f22e6b4a",
  null
  
)

export default component.exports